export enum SCRAPER_REQ_FIELD_KEY {
  // 사용자 입력 필드들
  TITLE = 'title',
  PRODUCT_LINE = 'product_line',
  BRAND = 'brand',
  PRODUCT_NAME = 'product_name',
  LINKS = 'links',
  LINK = 'link',

  // 공용 필드
  ITEM_PER_DAY = 'item_per_day',
  MAX_ITEMS = 'max_items',
  LANGUAGE = 'language',
  SCHEDULE = 'schedule',
  SHIFT_DAYS = 'shift_days',

  // Search fields
  USERNAME = 'username',
  KEYWORD = 'keyword',
  KEYWORDS = 'keywords',
  PAGE_URL = 'page_url',
  GROUP_ALIAS = 'group_alias',

  // Custom fields
  CAFE_ID = 'cafe_id',
  CAFE_NAME = 'cafe_name',

  // Search params fields
  EXACT_MATCH = 'exact_match',
  SORT = 'sort',
  SUBREDDIT = 'subreddit',

  // Keyword filters
  INCLUDE_KEYWORDS = 'include_keywords',
  EXCLUDE_KEYWORDS = 'exclude_keywords',

  // All options for amazon
  ALL_OPTIONS = 'all_options',

  // noise filter
  DEFINITION = 'definition',
}

export type FieldProperty = {
  name: string;
  desc: string;
  type: 'string' | 'string[]' | 'boolean' | 'number';
  required: boolean;
};

export const FieldPropertyMap = new Map<SCRAPER_REQ_FIELD_KEY, FieldProperty>([
  [
    SCRAPER_REQ_FIELD_KEY.TITLE,
    {
      name: 'Title',
      desc: 'The title of the scraping job.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.SHIFT_DAYS,
    {
      name: 'Shift days',
      desc: 'The shift days to shift the scraping job.',
      type: 'number',
      required: false,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.ITEM_PER_DAY,
    {
      name: 'Daily limit',
      desc: 'The daily feedback collection limit of the scraping job.',
      type: 'number',
      required: false,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.PRODUCT_LINE,
    {
      name: 'Product line',
      desc: 'The product category or line that the product relates to.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.BRAND,
    {
      name: 'Brand',
      desc: 'The brand of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.PRODUCT_NAME,
    {
      name: 'Product name',
      desc: 'The product name of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.LINKS,
    {
      name: 'Links',
      desc: 'The links of the feedback.',
      type: 'string[]',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.LINK,
    {
      name: 'Link',
      desc: 'The link of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.USERNAME,
    {
      name: 'Username',
      desc: 'The username of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.KEYWORD,
    {
      name: 'Keyword',
      desc: 'The keyword of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.KEYWORDS,
    {
      name: 'Keywords',
      desc: 'The keywords of the feedback.',
      type: 'string[]',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.PAGE_URL,
    {
      name: 'Page url',
      desc: 'The page url of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.GROUP_ALIAS,
    {
      name: 'Group alias',
      desc: 'The Facebook private group alias.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.CAFE_ID,
    {
      name: 'Cafe id',
      desc: 'The cafe id of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.CAFE_NAME,
    {
      name: 'Cafe name',
      desc: 'The cafe name of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.EXACT_MATCH,
    {
      name: 'Exact match',
      desc: 'The exact match of the feedback.',
      type: 'boolean',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.SORT,
    {
      name: 'Sort',
      desc: 'The sort of the feedback.',
      type: 'string',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.SUBREDDIT,
    {
      name: 'Subreddit',
      desc: 'Search feedback within a specific subreddit.',
      type: 'string',
      required: false,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.INCLUDE_KEYWORDS,
    {
      name: 'Include keywords',
      desc: 'Scraping feedback that includes the keywords.',
      type: 'string[]',
      required: false,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.EXCLUDE_KEYWORDS,
    {
      name: 'Exclude keywords',
      desc: 'Scraping feedback that excludes the keywords.',
      type: 'string[]',
      required: false,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.ALL_OPTIONS,
    {
      name: 'All options',
      desc: 'Specifies if reviews for all product variants should be collected. `true`: All variants. `false`: Specific URL option only.',
      type: 'boolean',
      required: true,
    },
  ],
  [
    SCRAPER_REQ_FIELD_KEY.DEFINITION,
    {
      name: 'Definition',
      desc: 'Describe what this term means in your specific context.',
      type: 'string',
      required: false,
    },
  ],
]);
